
export const COST_PER_DEVICE_PER_DAY = 25;
export const VAT_RATE = 0.15;
export const BASE_DISCOUNT_RATE = 0.05;
export const MAX_DISCOUNT_RATE = 0.30;

export const formatAmount = (num?: number | string | null) => {
  const value = typeof num === 'string' ? parseFloat(num) : num;
  const safe = typeof value === 'number' && isFinite(value) ? value : 0;
  return safe.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const generatePONumber = () => {
  // Use microseconds to ensure uniqueness
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 10000);
  return `PO-${timestamp}-${random}`;
};
